export default __webpack_public_path__ + "media/images/front/about/note-dd5aa8429a35f880f9d9bd450201910e.png";